import { render, staticRenderFns } from "./VideoListDialog.vue?vue&type=template&id=2ea57b36&scoped=true"
import script from "./VideoListDialog.vue?vue&type=script&lang=js"
export * from "./VideoListDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoListDialog.vue?vue&type=style&index=0&id=2ea57b36&prod&scoped=true&lang=scss"
import style1 from "./VideoListDialog.vue?vue&type=style&index=1&id=2ea57b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea57b36",
  null
  
)

export default component.exports